<template>
  <div class="row mt-5">
    <div class="col-xl-5" v-if="checkForPermission(add_day_zone_permission)">
      <day-zone-form button_text="Add Day Zone" @zoneAction="addZone"/>
    </div>
    <div class="col-xl-1"></div>
    <div class="col-xl-6">
      <TableLoading v-if="assignedDays.page === 0"/>
      <data-table v-else :columns="columns" :rows="assignedDays.objects">
        <template v-slot:actions="slotProps" v-if="checkForPermission(delete_day_zone_permission)">
          <b-button variant="danger" size="sm" class="py-1 text-white" @click="removeDayAssignment(slotProps.row.publicId)">
            Delete
          </b-button>
        </template>
      </data-table>
    </div>
  </div>
</template>

<script>
import DayZoneForm from "@/components/settings/day-zone-form";
import DataTable from "@/components/data-table";
import {ALL_DAY_ZONE_ASSIGNMENTS} from "@/gql/system-settings";
import {mapActions} from "vuex";
import {successToast} from "@/components/successToast";
import TableLoading from "@/components/TableLoading";
import {permissions} from "@/router/permissions";
export default {
name: "day-zone-component",
  components: {TableLoading, DataTable, DayZoneForm},
  data(){
    return{
      searchTerm: '',
      selected_zone_assignment: {},
      add_day_zone_permission: permissions.add_day_zone_permission,
      delete_day_zone_permission: permissions.delete_day_zone_permission,
      columns: [
        {
          field: 'zone.name',
          label: 'Zone Name'
        },
        {
          field: 'deliveryDay',
          label: 'Day'
        },
        {
          field: 'actions',
          label: 'Action'
        }
      ],
      assignedDays: {
        page: 0,
        objects: []
      }
    }
  },
  apollo: {
    assignedDays: {
      query: ALL_DAY_ZONE_ASSIGNMENTS,
      variables(){
        return {
          page: 1,
          perPage: 30
        }
      }
    }
  },
  methods: {
    ... mapActions({
      addDayZone: 'settings/addNewDayZoneAssignment',
      deleteDayZoneAssignment: 'settings/deleteDayZoneAssignment',
    }),
    async addZone(data){
      await this.addDayZone(data).then(resp => {
        if(resp.message){
          this.updateDayZoneQuery()
          successToast(`${resp.message}`)
        }

      })
    },
    async removeDayAssignment(id){
      await this.deleteDayZoneAssignment({'id': id}).then(resp => {
        if(resp.message){
          this.updateDayZoneQuery()
          successToast(`${resp.message}`)
        }
      })
    },
    updateDayZoneQuery(){
      this.$apollo.queries.assignedDays.refetch()
    }
  }
}
</script>

<style scoped>

</style>
